import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import StyleSheet from 'styles'

export class FlexDataView extends PureComponent {
  render = () =>
    <div {...this.props} className={`${styles.flexContainer} ${this.props.className}`} />
}

export class FlexDataItem extends PureComponent {
  static propTypes = {
    size: PropTypes.oneOf(['xlarge', 'large', 'medium', 'small'])
  }

  static defaultProps = {
    size: 'small'
  }

  get hasSubContainer() {
    return React.Children.map(this.props.children, child => child && child.type === FlexDataView).some(c => c)
  }

  render = () =>
    <div {...this.props} className={`${styles('flexItem', this.props.size, {subContainer: this.hasSubContainer})} ${this.props.className}`} />
}

export const styles = StyleSheet({
  flexContainer: {
    flex: 1,
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    margin: -10,
    marginBottom: 10,
  },
  flexItem: {
    minWidth: 280,
    margin: 10,
    boxSizing: 'border-box',
    position: 'relative',
    backgroundColor: '#eeeeee',
    '&$subContainer': {
      backgroundColor: 'transparent',
      '& > $flexContainer': {
        minHeight: 'calc(100% + 20px)',
      }
    },
    '& h6': {
      color: 'rgba(0,0,0,0.87)',
      margin: [10, 10, 0, 15],
      lineHeight: '40px',
      '& svg': {
        width: 32,
        height: 32,
        margin: [0, 10, -10, -5],
      },
    },
    '& p': {
      padding: [0, 15, 15, 15],
      lineHeight: '16px',
      fontSize: '12px',
    },
    '& dl': {
      margin: 0,
      padding: [20, 15, 10, 15],
      display: 'flex',
      flexWrap: 'wrap',
      fontSize: '12px',
      lineHeight: '16px',
      '& dt': {
        width: 150,
        whiteSpace: 'nowrap'
      },
      '& dd': {
        fontWeight: 'bold',
        flexBasis: '25%',
        minWidth: '150px',
        flex: 1,
        marginLeft: -150,
        paddingTop: 22,
        paddingBottom: 25,
        paddingRight: 10,
        boxSizing: 'border-box'
      },
      '&::after': {
        content: "''",
        height: 0,
        flex: 1,
        flexBasis: '25%',
        minWidth: '150px',
      }
    },
    '& ul': {
      padding: 0,
      margin: 0,
      '& li': {
        listStyle: 'none',
        marginBottom: 8,
      }
    }
  },
  small: {
    flex: 1,
    flexBasis: 'calc(33% - 20px)',
  },
  medium: {
    flex: '1',
    flexBasis: 'calc(50% - 20px)',
  },
  large: {
    flex: '2',
    flexBasis: 'calc(66% - 20px)',
  },
  xlarge: {
    flex: '3',
    flexBasis: '100%',
  },
  subContainer: {

  },
})

export default FlexDataView